// Shared configuration for positioning and sizing constants
// This ensures consistency between server and frontend
// Copy this file to src/shared-config.ts in the frontend

export const LAYOUT_CONFIG = {
  // Member/Method sizing
  baseMemberHeight: 40, // Base height for method name
  callNodeHeight: 30, // Height per method call (used for both invoke and call nodes)
  methodCallSpacing: 10, // Spacing between method calls
  memberPadding: 50, // Padding around member content
  memberSpacing: 10, // Spacing between members in a column

  // Class sizing
  classSpacing: 50, // Minimum spacing between classes
  groupPaddingSize: 100, // Padding around class groups

  // Column layout
  columnWidth: 280, // Width of each method column
  columnSpacing: 70, // Space between method columns
  categoryColumnSpacing: 1400, // Space between category columns (controllers, services, utils)

  // Starting positions
  startX: 0, // 100,
  startY: 0, // 100,

  // Additional positioning constants
  memberOffsetFromClass: 50, // Offset from class top to first member
  memberWidthReduction: 10, // Reduction from column width for member width

  // Frontend-specific constants
  methodWidth: 250, // Width of method groups in frontend
  methodSpacing: 60, // Spacing between method groups in frontend
  publicPrivateGap: 50, // Gap between public/private columns in frontend
} as const;

// Helper function to calculate member height based on method calls
export function calculateMemberHeight(methodCallCount: number): number {
  return (
    LAYOUT_CONFIG.baseMemberHeight +
    methodCallCount *
      (LAYOUT_CONFIG.callNodeHeight + LAYOUT_CONFIG.methodCallSpacing) +
    LAYOUT_CONFIG.memberPadding
  );
}

// Type definitions for better IDE support
export type LayoutConfig = typeof LAYOUT_CONFIG;
